module.exports = __webpack_public_path__ + "static/media/urban-farming-mobile.aa89a589.jpg";